import { CardTitle } from "@/modern/components/ui/card";
import { DashboardCard } from "@/modern/components/dashboard-card";
import { Button } from "@/modern/components/ui/button-shadcn";
import { ButtonGroup } from "@/modern/components/ui/button-group";
import { ArrowLeft, Expand, PlusIcon } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/modern/components/ui/tooltip";
import { ChecklistList } from "./components/ChecklistList";
import { EmptyChecklistsState } from "./components/EmptyChecklistsState";
import { ChecklistProgress } from "./components/ChecklistProgress";
import { ChecklistItemList } from "./components/ChecklistItemList";
import { cn } from "@/modern/utils";
import { EntityChecklistProvider, useEntityChecklistContext } from "./context/EntityChecklistContext";
import { useEntityManagerContext } from "@/react/components/entityManager/context/EntityManagerContext";

export const EntityChecklistContent = () => {
  const { selectedChecklist, handleHideChecklistDetails, handleShowChecklistDetails, handleOpenEditor, hasChecklists, checklists, selectedChecklistItems, canEditSelectedChecklist } = useEntityChecklistContext();

  return (
    <DashboardCard
      className="h-[30rem]"
      cardContentClassName="h-full flex flex-col p-3"
      header={
        <div className="flex items-center justify-between w-full">
          <CardTitle className={cn("text-base gap-3 flex items-center truncate min-w-0", selectedChecklist?.archived && "line-through")}>
            {selectedChecklist && (
              <Button variant="ghost" size="icon" className="size-7 p-0 text-muted-foreground" onClick={() => handleHideChecklistDetails()}>
                <ArrowLeft className="size-4" />
              </Button>
            )}
            <span className="truncate min-w-0 pr-2">
              {selectedChecklist?.title || "Checklists"}
            </span>
          </CardTitle>
          <ButtonGroup>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="entityHeader" className={cn(selectedChecklist && "w-auto px-3")} size="icon" onClick={() => handleOpenEditor(!selectedChecklist)}>
                  {selectedChecklist ? (
                    <>
                      <Expand className="size-4" /> {canEditSelectedChecklist && "Edit"}
                    </>
                  ) : (
                    <>
                      <PlusIcon className="size-4" />
                    </>
                  )}
                </Button>
              </TooltipTrigger>
              <TooltipContent>{selectedChecklist ? `${canEditSelectedChecklist ? "Edit" : "View"} checklist` : "Add checklist"}</TooltipContent>
            </Tooltip>
          </ButtonGroup>
        </div>
      }
    >
      {hasChecklists ? (
        <>
          {selectedChecklist ? (
            <div className="flex flex-col gap-4 pt-1">
              <ChecklistProgress
                checklist={selectedChecklist}
                checklistItems={selectedChecklistItems}
              />
              <ChecklistItemList
                checklistItems={selectedChecklistItems}
                uiConfig={{
                  showImageHandler: true,
                  showComment: true,
                  showButtonsOnHover: true,
                  showDeleteHandler: false,
                  showDragHandle: false,
                }}
              />
            </div>
          ) : (
            <ChecklistList
              checklists={checklists}
              onShowDetails={handleShowChecklistDetails}
            />
          )}
        </>
      ) : (
        <EmptyChecklistsState onOpenEditor={handleOpenEditor} />
      )}
    </DashboardCard>
  );
}

export const EntityChecklistView = () => {
  const { record } = useEntityManagerContext();
  return (<EntityChecklistProvider record={record}>
    <EntityChecklistContent />
  </EntityChecklistProvider>)
};
